import {
    GET_TEAM_MEMBERS_FAILURE,
    GET_TEAM_MEMBERS_REQUEST,
    GET_TEAM_MEMBERS_SUCCESS
} from "../actions";

const initialState = {
    loading: false,
    data: [],
    error: "",
};

const getTeamMembersByAdminReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_TEAM_MEMBERS_REQUEST:
            return {
                ...state,
                loading: true,
                data: [],
            };

        case GET_TEAM_MEMBERS_SUCCESS:
            return {
                loading: false,
                data: action.payload,
                error: "",
            };
        case GET_TEAM_MEMBERS_FAILURE:
            return {
                loading: false,
                data: [],
                error: action.payload,
            };
        default:
            return state;
    }
};
export default getTeamMembersByAdminReducer;
